import { PageContainer } from "@/components/organisms";
import { SectionTitle, InfoItem } from "@/components/molecules";

const OrderItemPriceInfo = ({ orderItemPriceInfoData }) => {
  const getValue = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      <PageContainer>
        <div className="order-overview">
          <div className="sc-border grid pl-4">
            <SectionTitle id="Quantity_Details" label="Quantity Details" />
          </div>
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            <InfoItem
              label="Quantity Request"
              value={getValue(orderItemPriceInfoData?.requestedQuantity)}
            />
            <InfoItem
              label="Quantity Confirmed"
              value={getValue(orderItemPriceInfoData?.confirmedQuantity)}
            />
          </div>
          <div className="sc-border grid pl-4">
            <SectionTitle id="Pricing_Breakdown" label="Pricing Breakdown" />
          </div>
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            <InfoItem
              label="Base Price"
              value={getValue(orderItemPriceInfoData?.unitPrice)}
            />
            <InfoItem
              label="Discount"
              value={getValue(orderItemPriceInfoData?.discount)}
            />
            <InfoItem
              label="Discount Including Tax"
              value={getValue(orderItemPriceInfoData?.discountIncludingTax)}
            />
            <InfoItem
              label="Tax Amount"
              value={getValue(orderItemPriceInfoData?.taxAmount)}
            />
            <InfoItem
              label="Grand Total"
              value={getValue(orderItemPriceInfoData?.grandTotal)}
            />
          </div>
          <div className="sc-border grid pl-4">
            <SectionTitle id="Deposits_and_Adjustments" label="Deposits and Adjustments" />
          </div>
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            <InfoItem
              label="Tax Deposit Amount"
              value={getValue(orderItemPriceInfoData?.taxDepositAmount)}
            />
            <InfoItem
              label="Security Deposit"
              value={getValue(orderItemPriceInfoData?.securityDeposit)}
            />
            <InfoItem
              label="Sugar Levy Tax"
              value={getValue(
                orderItemPriceInfoData?.sugarLevyTax,
              )}
            />
          </div>
          <div className="sc-border grid pl-4">
            <SectionTitle id="Additional_Pricing_Information" label="Additional Pricing Information" />
          </div>
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            <InfoItem
              label="Conversion"
              value={getValue(orderItemPriceInfoData?.conversion)}
            />
            <InfoItem
              label="Promotion Point"
              value={getValue(orderItemPriceInfoData?.promotionPoint)}
            />
            <InfoItem
              label="Price List ID"
              value={getValue(orderItemPriceInfoData?.priceListId)}
            />
            <InfoItem
              label="ID Agreement"
              value={getValue(
                orderItemPriceInfoData?.idAgreement,
              )}
            />
          </div>
          <div className="sc-border grid pl-4">
            <SectionTitle id="Invoice_Price_Information" label="Invoice Price Information" />
          </div>
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            <InfoItem
              label="Unit Price Amount"
              value={getValue(orderItemPriceInfoData?.unitPrice)}
            />
            <InfoItem
              label="Total Gross Amount"
              value={getValue(orderItemPriceInfoData?.totalGrossAmount)}
            />
            <InfoItem
              label="Total Discount Amount"
              value={getValue(orderItemPriceInfoData?.totalDiscountAmount)}
            />
            <InfoItem
              label="Total Tax Amount"
              value={getValue(
                orderItemPriceInfoData?.totalTaxAmount,
              )}
            />
            <InfoItem
              label="Total Net Amount"
              value={getValue(orderItemPriceInfoData?.totalNetAmount)}
            />
            <InfoItem
              label="Total Promotion Amount"
              value={getValue(
                orderItemPriceInfoData?.totalPromotionAmount,
              )}
            />
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default OrderItemPriceInfo;
